import { useLocation } from "react-router-dom";
import { MobileHeader } from "../components/Header/MobileHeader";
import { BottomNav } from "../components/Navigation/BottomNav";
import { useResponsive } from "../hooks/useResponsive";
import { useTranslation } from "react-i18next";

export const MobileContent = ({ children }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { isIOS, isAndroid } = useResponsive();

  const getTitle = () => {
    switch (location.pathname) {
      case "/":
        return t("sidebar.menu.bookmarks");
      case "/collections":
        return t("sidebar.menu.collectionsShort");
      case "/settings":
        return t("sidebar.menu.settings.title");
      case "/settings/account":
        return t("sidebar.menu.settings.account");
      case "/settings/preferences":
        return t("settings.preferences.title");
      case "/settings/integration":
        return t("settings.integration.title");
      case "/settings/security":
        return t("settings.security.title");
      default:
        return "onBookmarks";
    }
  };

  const mobileDeviceClass = isIOS ? "ios" : isAndroid ? "android" : "browser";

  return (
    <div className={`mobile-view ${mobileDeviceClass}`}>
      <MobileHeader title={getTitle()} />

      <main className="main-content py-4 px-3">
        <div className="pull-indicator">
          <div className="spinner"></div>
        </div>
        {children}
      </main>

      <BottomNav />
    </div>
  );
};
